import { Chess } from "@chesshotel/chess";
import { ChessTermType, TermAction, } from "@chesshotel/types";
function uciToMove(uci) {
    if (!uci || uci.length < 4)
        return null;
    return {
        from: uci.slice(0, 2),
        to: uci.slice(2, 4),
        promotion: uci.length > 4 ? uci.slice(4) : undefined,
    };
}
function pvReachesCheckmate(fen, pvMoves, mateInMoves) {
    if (!fen || !pvMoves?.length || !mateInMoves)
        return false;
    const chess = new Chess(fen);
    const maxPlies = Math.min(pvMoves.length, Math.max(1, Math.abs(mateInMoves) * 2));
    for (let i = 0; i < maxPlies; i++) {
        const move = uciToMove(pvMoves[i]);
        if (!move)
            return false;
        try {
            const result = chess.move(move);
            if (!result)
                return false;
        }
        catch {
            return false;
        }
        if (chess.isCheckmate())
            return true;
    }
    return chess.isCheckmate();
}
export async function detectNegativeFollowsCheckmate(position, lastPosition) {
    const chess = new Chess(position.fen);
    const color = chess.turn();
    if (lastPosition.mateInMoves &&
        !position.mateInMoves &&
        pvReachesCheckmate(lastPosition.fen, lastPosition.pvMoves, lastPosition.mateInMoves)) {
        return {
            term: ChessTermType.FOLLOW_CHECKMATE,
            termAction: TermAction.MISS,
            movesUntilImpact: lastPosition.mateInMoves,
            translationKeys: {
                mateMoves: Math.abs(lastPosition.mateInMoves),
                color,
            },
            pvMoves: lastPosition.pvMoves,
            maxGain: 10,
        };
    }
    if (!lastPosition.mateInMoves &&
        position.mateInMoves &&
        pvReachesCheckmate(position.fen, position.pvMoves, position.mateInMoves)) {
        return {
            term: ChessTermType.FOLLOW_CHECKMATE,
            termAction: TermAction.ALLOW,
            movesUntilImpact: position.mateInMoves,
            translationKeys: {
                mateMoves: Math.abs(position.mateInMoves),
                color,
            },
            pvMoves: position.pvMoves,
            maxGain: 10,
        };
    }
    if (lastPosition.mateInMoves &&
        position.mateInMoves &&
        lastPosition.mateInMoves <= -position.mateInMoves &&
        pvReachesCheckmate(position.fen, position.pvMoves, position.mateInMoves)) {
        return {
            term: ChessTermType.FOLLOW_CHECKMATE,
            termAction: TermAction.POSPONE,
            movesUntilImpact: position.mateInMoves,
            translationKeys: {
                mateMoves: Math.abs(position.mateInMoves),
                color,
            },
            pvMoves: position.pvMoves,
            maxGain: 10,
        };
    }
}
export function detectPositiveFollowsCheckmate(position, lastPosition) {
    const chess = new Chess(lastPosition.fen);
    const color = chess.turn();
    if (lastPosition.mateInMoves &&
        position.mateInMoves &&
        lastPosition.mateInMoves > -position.mateInMoves &&
        pvReachesCheckmate(position.fen, position.pvMoves, position.mateInMoves)) {
        return {
            term: ChessTermType.FOLLOW_CHECKMATE,
            termAction: TermAction.PERFORM,
            movesUntilImpact: position.mateInMoves,
            translationKeys: {
                mateMoves: Math.abs(position.mateInMoves),
                color,
            },
            pvMoves: position.pvMoves,
            maxGain: 10,
        };
    }
}
//# sourceMappingURL=ending.js.map